import React, { useState } from 'react'
import { Icon } from '@iconify/react';
import { ToastContainer } from 'react-toastify';
import ClassroomAssignmentResources from './ClassroomAssignmentResources'
import ClassroomAssignmentResponse from './ClassroomAssignmentResponse'
import { usePermissions } from '../../../context/PermissionsContext';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { decodeData } from '../../../utils/encodeAndEncode';

function ClassroomAssignmentDetails() {
  const [activeTab, setActiveTab] = useState('resources');
  const { permissions } = usePermissions();
  const { classroomId, assignmentId } = useParams();
  const decodedClassroomId = decodeData(classroomId);
  const decodedAssignmentId = decodeData(assignmentId);

  const handleTabChange = (tab) => {
    if (tab === 'resources' && !permissions.classroom_assignment_resource_view) {
      toast.warning("You don't have permission to view resources");
      return;
    }
    if (tab === 'response' && !permissions.classroom_assignment_response_view) {
      toast.warning("You don't have permission to view responses");
      return;
    }
    setActiveTab(tab);
  };

  return (
    <div className="flex">
      <div className="w-full">
        <div className="bg-white rounded-lg shadow-sm border border-gray-100">
          <div className="p-0">

            {/* Tabs */}
            <div className="border-b border-gray-200">
              <ul className="flex border-b border-gray-200">
                <li>
                  <button
                    className={`flex items-center px-4 py-3 border-b-2 transition-colors ${
                      activeTab === 'resources' 
                        ? 'border-primary text-primary font-medium' 
                        : 'border-transparent text-gray-500 hover:text-gray-700'
                    }`}
                    onClick={() => handleTabChange('resources')}
                    disabled={!permissions.classroom_assignment_resource_view}
                    title={!permissions.classroom_assignment_resource_view ? "You don't have permission to view resources" : "View assignment resources"}
                  >
                    <Icon icon="fluent:document-24-regular" className="mr-2" width="20" height="20" />
                    Resources
                  </button>
                </li>
                <li>
                  <button
                    className={`flex items-center px-4 py-3 border-b-2 transition-colors ${
                      activeTab === 'response' 
                        ? 'border-primary text-primary font-medium' 
                        : 'border-transparent text-gray-500 hover:text-gray-700'
                    }`}
                    onClick={() => handleTabChange('response')}
                    disabled={!permissions.classroom_assignment_response_view}
                    title={!permissions.classroom_assignment_response_view ? "You don't have permission to view responses" : "View assignment responses"}
                  >
                    <Icon icon="fluent:chat-24-regular" className="mr-2" width="20" height="20" />
                    Response
                  </button>
                </li>
              </ul>
            </div>

            {/* Tab Content */}
            <div className="p-2">
              {activeTab === 'resources' && permissions.classroom_assignment_resource_view && (
                <div className="resources">
                  <ClassroomAssignmentResources decodedClassroomId={decodedClassroomId} decodedAssignmentId={decodedAssignmentId} />
                </div>
              )}

              {activeTab === 'response' && permissions.classroom_assignment_response_view && (
                <div className="response">
                  <ClassroomAssignmentResponse decodedClassroomId={decodedClassroomId} decodedAssignmentId={decodedAssignmentId} />
                </div>
              )}

              {((activeTab === 'resources' && !permissions.classroom_assignment_resource_view) ||
                (activeTab === 'response' && !permissions.classroom_assignment_response_view)) && (
                <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 px-4 py-3 rounded-lg m-3">
                  You don't have permission to view this content.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer limit={3} />
    </div>
  )
}

export default ClassroomAssignmentDetails
